/**
 * Created by calhosh on 4/14/2017.
 */

import * as english from './en-us';
import * as japanese from './ja-jp';
import * as frenchCanadian from './fr-ca';
import * as spanish from './es';
import * as portuguese from './pt-br';
import * as chineseSimplified from './zh-cn';
import * as chineseTraditional from './zh-tw';
import * as hebrew from './he';
import * as korean from './ko';
import * as russian from './ru';
import * as arabic from './ar';
import _ from 'lodash';

const languages = {
	'eng': english,
	'jpn': japanese,
	'fre': frenchCanadian,
	'spa': spanish,
	'por': portuguese,
	'zh-s': chineseSimplified,
	'zh-t': chineseTraditional,
	'heb': hebrew,
	'kor': korean,
	'rus': russian,
	ar: arabic
};

export default function(locale) {
	return _.merge({}, languages['eng'], languages[locale]);
}
